import * as req from 'api/actions';
import * as c from './constant';

export const getTaxAmnestyList = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_TAX_AMNESTY_OVR,
    'api/temp/administrators/tax_amnesty_ordinances',
    payload,
    callback
  );

export const getSingleTaxAmnesty = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_TAX_AMNESTY_OVR,
    `api/temp/administrators/tax_amnesty_ordinances/${id}`,
    payload,
    callback
  );

export const createTaxAmnesty = (payload, callback) =>
  req.create(
    c.CREATE_TAX_AMNESTY_OVR,
    'api/temp/administrators/tax_amnesty_ordinances',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateTaxAmnesty = (id, payload, callback) =>
  req.update(
    c.UPDATE_TAX_AMNESTY_OVR,
    `api/temp/administrators/tax_amnesty_ordinances/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const deleteTaxAmnesty = (id, payload, callback) =>
  req.remove(
    c.DELETE_TAX_AMNESTY_OVR,
    `api/temp/administrators/tax_amnesty_ordinances/${id}`,
    payload,
    callback
  );

export const getOrdinanceRevisionEffectivity = (payload, callback) =>
  req.list(
    c.GET_ORDINANCE_REVISION_EFFECTIVITY_AMNSESTY_OVR,
    `/api/v1/bpls/administrator/common/ordinance_revisions`,
    payload,
    callback
  );

export const expireSoa = (id, callback) =>
  req.create(
    c.EXPIRE_SOA_OVR,
    `api/temp/administrators/tax_amnesty_ordinances/${id}/expire_soa`,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

  export const clearItem = (constant, value) => req.setItem(constant, value);
